define(
    'views/highlight_code.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/highlight_code_admin_style.html'
    ],
    function(Loader, Config, Helper, Sandbox, highlightCodeAdminStyleTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;
        var Cookie = Loader.Cookie;

        var HighlightCodeView = Loader.Backbone.View.extend(
            {
                styleEditor1: null,
                styleEditor2: null,

                events: Helper.prepareEventsForDevice(
                    {
                        'change #select_codemirror_scheme': 'selectScheme',
                        'click #codemirror_state_tumbler': 'toggleState'
                    },
                    Loader.eventType
                ),

                routes: {
                    // "/admin_style.php": "highlightAdminStyle"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render', 'selectScheme');

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });

                    this.model.get('highlightCode').bind('change', function(){
                        _this.renderAdminStyle();
                    });

                    this.model.get('highlightCode').bind('change:enabled', function(){
                        if (_this.model.get('highlightCode').get('enabled')) {
                            _this.enable();
                        }
                        else {
                            _this.disable();
                        }
                    });
                },

                highlightAdminStyle: function()
                {
                    $('textarea[name="content1"]')
                        .before('<strong>Структура style.css</strong>')
                        .attr({
                            'id': 'style1'
                        })
                        .parent()
                        .siblings(":first")
                        .hide()
                        .parent().css({
                            'border-left-width': '0em'
                        });

                    $('textarea[name="content2"]')
                        .before('<strong>Цвета style_cs.css</strong>')
                        .attr({
                            'id': 'style2'
                        })
                        .parent()
                        .siblings(":first")
                        .hide()
                        .parent().css({
                            'border-left-width': '0em'
                        });

                    /*$('.CodeMirror').css({
                        'width': $('textarea[name="content1"]').width()
                    });*/

                    $('div.adfs-box p:first').after('<div id="highlightStyle"></div>');

//                    $r('div.adfs-box > p:eq(1)').before('<p><span class="adlabel" class="fl">Поиск в style.css</span><br /><span class="adinput"><input type="text" /><em></em></span></p>');
//                    $r('div.adfs-box > p:eq(3)').before('<p><span class="adlabel" class="fl">Поиск в style_cs.css</span><br /><span class="adinput"><input type="text" /><em></em></span></p>');

                    this.renderAdminStyle();

                    if (this.model.get('highlightCode').get('enabled')) {
                        this.enable();
                    } else {
                        this.enable();
                        this.disable();
                    }
                },

                enable: function()
                {
                    var _this = this;
                    this.styleEditor1 = CodeMirror.fromTextArea(document.getElementById('style1'), {
                        lineNumbers: true,
                        matchBrackets: true,
                        theme: this.model.get('highlightCode').get('scheme'),
//                        width: width,
//                        height: 'dynamic',
                        onCursorActivity: function() {
                            _this.styleEditor1.setLineClass(_this.hlLine1, null);
                            _this.hlLine1 = _this.styleEditor1.setLineClass(_this.styleEditor1.getCursor().line, "activeline");
                        }
                    });
                    this.hlLine1 = this.styleEditor1.setLineClass(0, "activeline");
                    this.styleEditor2 = CodeMirror.fromTextArea(document.getElementById('style2'), {
                        lineNumbers: true,
                        matchBrackets: true,
                        theme: this.model.get('highlightCode').get('scheme'),
//                        width: width,
//                        height: 'dynamic',
                        onCursorActivity: function() {
                            _this.styleEditor2.setLineClass(_this.hlLine2, null);
                            _this.hlLine2 = _this.styleEditor2.setLineClass(_this.styleEditor2.getCursor().line, "activeline");
                        }
                    });
                    this.hlLine2 = this.styleEditor2.setLineClass(0, "activeline");
                },

                disable: function()
                {
                    this.styleEditor1.toTextArea();
                    this.styleEditor2.toTextArea();
                },

                renderAdminStyle: function()
                {
                    var elem = $('#highlightStyle');

                    var compiledTemplate = _.template(
                        highlightCodeAdminStyleTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    elem.html(compiledTemplate);
                },

                selectScheme: function()
                {
                    var scheme = $('#select_codemirror_scheme').val();
                    this.model.get('highlightCode').set('scheme', scheme);

                    this.styleEditor1.setOption('theme', scheme);
                    this.styleEditor2.setOption('theme', scheme);
                },

                toggleState: function()
                {
                    var state = !this.model.get('highlightCode').get('enabled');
                    this.model.get('highlightCode').set('enabled', state);
                }
            });

        return {
            initialize: function(model)
            {
                return new HighlightCodeView({
                    el: $("#pun-admain1"),
                    model: model
                })
            }
        }
    }
);

